var _defs, _rect, _circle, _polygon, _line, _line2, _line3, _line4, _path, _path2, _path3, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLexilensaiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    width: 400,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "traceGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#38bdf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2563eb"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "over"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "#0f172a",
    rx: 24
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 220,
    r: 110,
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.12,
    strokeDasharray: "6 8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "200,65 335,142 335,298 200,375 65,298 65,142",
    fill: "none",
    stroke: "#334155",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 65,
    x2: 200,
    y2: 220,
    stroke: "#1e293b",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 335,
    y1: 142,
    x2: 200,
    y2: 220,
    stroke: "#1e293b",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 142,
    x2: 200,
    y2: 220,
    stroke: "#1e293b",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 375,
    x2: 200,
    y2: 220,
    stroke: "#475569",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 200,20 L 200,120",
    fill: "none",
    stroke: "url(#traceGrad)",
    strokeWidth: 6,
    strokeLinecap: "round",
    filter: "url(#glow)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 200,120 L 140,180 L 140,265",
    fill: "none",
    stroke: "url(#traceGrad)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    filter: "url(#glow)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 200,120 L 260,180 L 260,265",
    fill: "none",
    stroke: "url(#traceGrad)",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    filter: "url(#glow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 120,
    r: 5,
    fill: "#ffffff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 265,
    r: 9,
    fill: "#2563eb",
    filter: "url(#glow)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 265,
    r: 4,
    fill: "#ffffff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 265,
    r: 9,
    fill: "#38bdf8",
    filter: "url(#glow)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 265,
    r: 4,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLexilensaiLogo);
export default __webpack_public_path__ + "static/media/lexilensai_logo.da2dfdcf1f3946967130fa5fe30baaec.svg";
export { ForwardRef as ReactComponent };